import locale from 'amumu-ui/src/locale'
import en from 'amumu-ui/src/locale/lang/en'
import zhCN from 'amumu-ui/src/locale/lang/zh-CN'
import zhTW from 'amumu-ui/src/locale/lang/zh-TW'
import Cookies from 'js-cookie'

const messages = {
  'en': en,
  'zh-CN': zhCN,
  'zh-TW': zhTW
}
const LOCALE_KEY = '_t_language'
const lang = Cookies.get(LOCALE_KEY)
const localeLang = Object.keys(messages).includes(lang) ? lang : 'zh-CN'
locale.use(messages[localeLang])
